<script>
    import * as Icons from 'lucide-svelte';
    import LyP from '../layouts/components/LyP.svelte';
    import LyHeader from '../layouts/components/LyHeader.svelte';
    import LySection from '../layouts/components/LySection.svelte';
    import LyContent from '../layouts/components/LyContent.svelte';
    import LyHeadline from '../layouts/components/LyHeadline.svelte';
    import { PageStore } from '../stores/PageStore.svelte.js';
    import LyGrid3 from '../layouts/components/LyGrid3.svelte';
    import LyButtons from '../layouts/forms/LyButtons.svelte';
    import LyButton from '../layouts/forms/LyButton.svelte';
</script>

<LyContent wrapper={true}>
    <LyHeader>
        <LyHeadline icon={Icons.BotMessageSquare}>AI</LyHeadline>
    </LyHeader>

    <LySection tag="div">
        <LyP>
            Hier ist die Zentrale für allen zu Thema <strong>AI-Integration</strong>.
        </LyP>
    </LySection>
</LyContent>

<LyGrid3 wrapper={true} mt={true}>
    <LyContent tag="article" addClass="flex h-full flex-col">
        <LyHeader>
            <LyHeadline weight={2} center={true}>AI-Inventur</LyHeadline>
        </LyHeader>
        <LyP center={true}>Wenn Du ein AI-System verwendest, musst Du es hier eintragen.</LyP>
        <div class="mt-auto">
            <LyButtons mt={true} center={true}>
                <LyButton label="Zur AI-Inventur" onclick={() => PageStore.set('/ai/announcements')} />
            </LyButtons>
        </div>
    </LyContent>
</LyGrid3>
